import { createContext, useContext } from "react"

import {
  GlobalSearchActiveTab,
  GlobalSearchOptionsMap,
  GlobalSearchSelectableOption
} from "features/global-search/types/GlobalSearch"

export interface GlobalSearchContextValue {
  searchTerm: string | null
  onSearchTermChange: (value: string | null) => void
  options: GlobalSearchOptionsMap
  hasResults: boolean
  isLoading: boolean
  onChange: (option: GlobalSearchSelectableOption | null) => void
  activeTab: GlobalSearchActiveTab
  onActiveTabChange: (tab: GlobalSearchActiveTab) => void
  statusId: string | undefined
  onStatusRegister: (id: string) => void
  history: string[]
}

const GlobalSearchContext = createContext<GlobalSearchContextValue | undefined>(
  undefined
)

export { GlobalSearchContext }

export function useGlobalSearchContext(): GlobalSearchContextValue {
  const context = useContext(GlobalSearchContext)
  if (!context) {
    throw new Error("useGlobalSearchContext must be used within a GlobalSearch")
  }
  return context
}
